import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12e54aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sm:flex flex-nowrap" }
const _hoisted_2 = { class: "sm:w-1/2 md:w-2/3 sm:mr-x2 md:mr-x6" }
const _hoisted_3 = {
  key: 1,
  class: "temp-height"
}
const _hoisted_4 = { class: "sm:w-1/2 md:w-1/3 sm:ml-x2 md:ml-x6" }

import { PropType, ref, Ref } from 'vue';
import {
    B2CCheckoutTileModel,
} from '@/types/B2CContentServerContract';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import CheckoutOrderSummary from '@/b2c/checkout/ui/CheckoutOrderSummary.vue';
import CheckoutSteps from '@/b2c/checkout/ui/CheckoutSteps.vue';
import { useCheckout } from '@/b2c/checkout/useCheckout';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2CCheckoutTile',
  props: {
    content: {
        type: Object as PropType<B2CCheckoutTileModel>,
        required: true,
    },
},
  setup(__props) {

const { init } = useCheckout();
const initialized: Ref<boolean> = ref(false);

const initialize = async(): Promise<void> => {
    await init();
    initialized.value = true;
};

initialize();




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_Transition, {
            name: "o-anim-fade-500",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (initialized.value)
                ? (_openBlock(), _createBlock(CheckoutSteps, {
                    key: 0,
                    class: "mx-auto max-w-750"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_3))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CheckoutOrderSummary)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})